import {useEffect, useState} from 'react';

import { db } from '../../../firebase';
import { collection, getDocs, doc, setDoc, getDoc } from "firebase/firestore";

import {useAuth} from "../../../contexts/authContext"

import styles from "./Banner.module.css"

import {AiOutlineSearch} from "react-icons/ai"


export default function Banner() {
  const {currentUser} = useAuth()

  const [username, setUsername] = useState("User");

  const getMessage = () => {
    const date = new Date();
    const hour = date.getHours();
    
    let message = "";

    if (hour < 12) {
      message = `Good morning, ${username}.`
    } else if (hour >= 12 && hour < 18) {
      message = `Good afternoon, ${username}.`
    } else {
      message = `Good evening, ${username}.`
    }

    return message;
  }

  const getUsername = async () => {
    const querySnapshot = await getDocs(collection(db, "users"));

    querySnapshot.forEach(async (doc) => {
      if (doc.id === currentUser.uid) {
        const displayName = doc.data().displayName;

        setUsername(displayName)
      }
    })
  }

  useEffect(() => {
    getUsername();
  }, [])

  return (
    <div className={styles.bannerContainer}>
      <div className={styles.banner}>
        <div>
          <h1>{getMessage()}</h1>

          <div className={styles.searchBarContainer}>
            <label htmlFor="searchBar"><AiOutlineSearch /></label>
            <input type="text" placeholder="Search for your designs" className={styles.searchBar} id="searchBar" />
          </div>
        </div>
      </div>
    </div>
  );
}
